// This global Vue instance is bootstrapped in bootstrap-vue.js so that components in other plugins can register with the same Vue instance
const Vue = window.Vue

export const SolidBkgOnScroll = {
  name: 'solid-bkg-on-scroll',
  // When the bound element is inserted into the DOM...
  inserted: function (el, binding) {
    // TODO: In the future, animate the position of this down
    var trackingElement = binding.value ? binding.value.element : el
    var elementHeight = $(trackingElement).height()
    $(window).on('scroll', function () {
      if ($(window).scrollTop() >= elementHeight) {
        $(el).addClass('solid-bg')
      } else if ($(window).scrollTop() < elementHeight) {
        $(el).removeClass('solid-bg')
      }
    })
  },
}

// You can also make it available globally.
Vue.directive('solid-bkg-on-scroll', SolidBkgOnScroll)
